import { render, staticRenderFns } from "./OngoingTestModal.vue?vue&type=template&id=7bfdd351&scoped=true"
import script from "./OngoingTestModal.vue?vue&type=script&lang=js"
export * from "./OngoingTestModal.vue?vue&type=script&lang=js"
import style0 from "./OngoingTestModal.vue?vue&type=style&index=0&id=7bfdd351&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfdd351",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VCard,VCardTitle,VDialog,VDivider,VSkeletonLoader})
